import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 341A3007-7214-4634-924D-1FFEA455AD5E
 * name arrow-left-right-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-right-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowLeftRightBoldOutlineIcon = createSvgIcon(<><path d="M14,16V22L24,12L14,2V8H10V2L0,12L10,22V16H14M8,14V17L3,12L8,7V10H16V7L21,12L16,17V14H8Z" /></>, 'ArrowLeftRightBoldOutlineIcon');
export default ArrowLeftRightBoldOutlineIcon